module.exports = __webpack_public_path__ + "img/speaker_17.8b166fdd.jpg";